export default __webpack_public_path__ + "static/media/smiley_survey_bg.04b91cf6.svg";